/* Navita Points (fase 8) — painel do programa de pontos e troca no carrinho.
   Fala com a app Navita Points por /apps/pontos/* (app proxy: a Shopify diz à app quem é a cliente com sessão iniciada).
   1. Botão + painel (snippets/navita-pontos-painel.liquid): saldo, nível, trocar, ganhar mais, convite, códigos, histórico.
   2. Botões [data-npts-trocar] no carrinho (snippets/navita-carrinho-resumo.liquid, parte 'pontos'): troca e aplica o código.
   Depois de aplicar um código avisa o tema (CartLinesUpdateEvent), que volta a desenhar o carrinho sem recarregar a página. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.navitaPontos) {
  const cfgEl = document.getElementById('npts-config');
  const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { lingua: 'pt', sessao: false };
  const L = cfg.lingua;
  const LOCALE = { pt: 'pt-PT', es: 'es-ES', en: 'en-GB' }[L] || 'pt-PT';
  const API = '/apps/pontos/';

  const TXT = {
    pt: {
      junta: 'Junta-te ao', ola: 'Olá', pontos: 'Navita Points', pts: 'pontos', fechar: 'Fechar',
      visit: 'Ganha pontos em cada compra e troca-os por descontos, envio grátis e amostras de fio.',
      criar: 'Criar conta · +{p} pontos', jaTens: 'Já tens conta?', entrar: 'Inicia sessão',
      ganhar: 'Formas de ganhar', recompensas: 'Recompensas', trocarTit: 'Trocar pontos', ganharMais: 'Ganhar mais',
      convidaTit: 'Convida uma amiga', codigosTit: 'Os teus códigos', histTit: 'Histórico', comoFunciona: 'Como funciona',
      nivel: 'Nível {n}', faltaNivel: 'faltam {v} para {n}', topo: 'estás no nível mais alto',
      faltaRec: 'Faltam {p} pontos para {r}', tudo: 'Já podes trocar qualquer recompensa',
      validade: 'Os teus pontos são válidos até {d}. Cada compra volta a contar 12 meses.',
      trocar: 'Trocar', aTrocar: 'A trocar…', soTeu: 'o código é só teu', aplicar: 'Aplicar no carrinho', aplicado: 'Aplicado ✓',
      copiar: 'Copiar', copiado: 'Copiado', porUsar: 'por usar', usado: 'usado',
      encomenda: 'Fazer uma encomenda', porEuro: '{t} por cada 1 € (sem IVA)', registo: 'Criar conta', feito: '✓ Feito',
      insta: 'Seguir @navitahome no Instagram', tiktok: 'Seguir no TikTok', seguir: 'Seguir',
      aniv: 'Aniversário', anivTxt: '{p} pontos no teu dia. Indica a data pelo menos 30 dias antes.', dia: 'Dia', mes: 'Mês',
      guardar: 'Guardar', guardado: 'Guardado ✓',
      amigaRecebe: 'para ela, em compras a partir de {m}', tuRecebes: 'para ti, quando ela comprar', criarLink: 'Criar o meu link',
      convidadas: 'Já convidaste {n}.',
      vinte: '20% de desconto (até {m})', vinteCarrinho: 'Junta produtos ao carrinho para trocar os 20%: o desconto é calculado sobre o carrinho.',
      erro: 'Não foi possível. Tenta outra vez.', erroSaldo: 'Não tens pontos suficientes.', carregar: 'A carregar…',
      rec: { envio: 'Envio grátis', '5e': '{v} de desconto', amostras: '6 catálogos de amostras', '20p': '20% de desconto' },
      niveis: { bronze: 'Bronze', prata: 'Prata', ouro: 'Ouro' },
      hist: {
        encomenda: 'Encomenda {d}', reembolso: 'Reembolso · encomenda {d}', cancelamento: 'Encomenda cancelada {d}', registo: 'Criaste conta',
        aniversario: 'Aniversário', instagram: 'Seguiste no Instagram', tiktok: 'Seguiste no TikTok', nivel: 'Subiste a {n}',
        troca: 'Trocaste: {r}', estorno: 'Troca anulada: {r}', expiracao: 'Pontos expirados', ajuste: 'Acerto da Navita',
        smile: 'Saldo trazido da Smile', convite: 'A tua amiga comprou: ganhaste 3 €',
      },
    },
    es: {
      junta: 'Únete a', ola: 'Hola', pontos: 'Navita Points', pts: 'puntos', fechar: 'Cerrar',
      visit: 'Gana puntos en cada compra y cámbialos por descuentos, envío gratis y muestras de hilo.',
      criar: 'Crear cuenta · +{p} puntos', jaTens: '¿Ya tienes cuenta?', entrar: 'Inicia sesión',
      ganhar: 'Cómo ganar', recompensas: 'Recompensas', trocarTit: 'Canjear puntos', ganharMais: 'Gana más',
      convidaTit: 'Invita a una amiga', codigosTit: 'Tus códigos', histTit: 'Historial', comoFunciona: 'Cómo funciona',
      nivel: 'Nivel {n}', faltaNivel: 'te faltan {v} para {n}', topo: 'estás en el nivel más alto',
      faltaRec: 'Te faltan {p} puntos para {r}', tudo: 'Ya puedes canjear cualquier recompensa',
      validade: 'Tus puntos son válidos hasta el {d}. Cada compra vuelve a contar 12 meses.',
      trocar: 'Canjear', aTrocar: 'Canjeando…', soTeu: 'el código es solo tuyo', aplicar: 'Aplicar en el carrito', aplicado: 'Aplicado ✓',
      copiar: 'Copiar', copiado: 'Copiado', porUsar: 'sin usar', usado: 'usado',
      encomenda: 'Hacer un pedido', porEuro: '{t} por cada 1 € (sin IVA)', registo: 'Crear cuenta', feito: '✓ Hecho',
      insta: 'Seguir a @navitahome en Instagram', tiktok: 'Seguir en TikTok', seguir: 'Seguir',
      aniv: 'Cumpleaños', anivTxt: '{p} puntos en tu día. Indica la fecha al menos 30 días antes.', dia: 'Día', mes: 'Mes',
      guardar: 'Guardar', guardado: 'Guardado ✓',
      amigaRecebe: 'para ella, en compras desde {m}', tuRecebes: 'para ti, cuando ella compre', criarLink: 'Crear mi enlace',
      convidadas: 'Ya has invitado a {n}.',
      vinte: '20% de descuento (hasta {m})', vinteCarrinho: 'Añade productos al carrito para canjear el 20%: el descuento se calcula sobre el carrito.',
      erro: 'No ha sido posible. Inténtalo de nuevo.', erroSaldo: 'No tienes puntos suficientes.', carregar: 'Cargando…',
      rec: { envio: 'Envío gratis', '5e': '{v} de descuento', amostras: '6 catálogos de muestras', '20p': '20% de descuento' },
      niveis: { bronze: 'Bronce', prata: 'Plata', ouro: 'Oro' },
      hist: {
        encomenda: 'Pedido {d}', reembolso: 'Reembolso · pedido {d}', cancelamento: 'Pedido cancelado {d}', registo: 'Creaste tu cuenta',
        aniversario: 'Cumpleaños', instagram: 'Nos seguiste en Instagram', tiktok: 'Nos seguiste en TikTok', nivel: 'Subiste a {n}',
        troca: 'Canjeaste: {r}', estorno: 'Canje anulado: {r}', expiracao: 'Puntos caducados', ajuste: 'Ajuste de Navita',
        smile: 'Saldo traído de Smile', convite: 'Tu amiga compró: ganaste 3 €',
      },
    },
    en: {
      junta: 'Join', ola: 'Hi', pontos: 'Navita Points', pts: 'points', fechar: 'Close',
      visit: 'Earn points on every order and swap them for discounts, free shipping and cord samples.',
      criar: 'Create account · +{p} points', jaTens: 'Already have an account?', entrar: 'Sign in',
      ganhar: 'Ways to earn', recompensas: 'Rewards', trocarTit: 'Redeem points', ganharMais: 'Earn more',
      convidaTit: 'Invite a friend', codigosTit: 'Your codes', histTit: 'History', comoFunciona: 'How it works',
      nivel: '{n} tier', faltaNivel: '{v} to go for {n}', topo: 'you are on the top tier',
      faltaRec: '{p} more points for {r}', tudo: 'You can redeem any reward',
      validade: 'Your points are valid until {d}. Every order restarts the 12 months.',
      trocar: 'Redeem', aTrocar: 'Redeeming…', soTeu: 'this code is just for you', aplicar: 'Apply to cart', aplicado: 'Applied ✓',
      copiar: 'Copy', copiado: 'Copied', porUsar: 'unused', usado: 'used',
      encomenda: 'Place an order', porEuro: '{t} per €1 spent (excl. VAT)', registo: 'Create an account', feito: '✓ Done',
      insta: 'Follow @navitahome on Instagram', tiktok: 'Follow us on TikTok', seguir: 'Follow',
      aniv: 'Birthday', anivTxt: '{p} points on your day. Add the date at least 30 days before.', dia: 'Day', mes: 'Month',
      guardar: 'Save', guardado: 'Saved ✓',
      amigaRecebe: 'for her, on orders from {m}', tuRecebes: 'for you, when she orders', criarLink: 'Create my link',
      convidadas: 'You have invited {n}.',
      vinte: '20% off (up to {m})', vinteCarrinho: 'Add products to your cart to redeem the 20%: the discount is worked out on your cart.',
      erro: 'Something went wrong. Please try again.', erroSaldo: 'You don’t have enough points.', carregar: 'Loading…',
      rec: { envio: 'Free shipping', '5e': '{v} off', amostras: '6 sample catalogues', '20p': '20% off' },
      niveis: { bronze: 'Bronze', prata: 'Silver', ouro: 'Gold' },
      hist: {
        encomenda: 'Order {d}', reembolso: 'Refund · order {d}', cancelamento: 'Order cancelled {d}', registo: 'You created an account',
        aniversario: 'Birthday', instagram: 'You followed us on Instagram', tiktok: 'You followed us on TikTok', nivel: 'You reached {n}',
        troca: 'You redeemed: {r}', estorno: 'Redemption cancelled: {r}', expiracao: 'Points expired', ajuste: 'Adjustment by Navita',
        smile: 'Balance brought over from Smile', convite: 'Your friend ordered: you earned €3',
      },
    },
  }[L] || {};

  const ICONES = {
    saco: '<path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    pessoa: '<circle cx="12" cy="8" r="4"/><path d="M4 21c1.2-4 4.3-6 8-6s6.8 2 8 6"/>',
    bolo: '<path d="M4 20h16v-7H4v7Z"/><path d="M4 16c2 1.2 4 1.2 6 0s4-1.2 6 0 3 1 4 .5"/><path d="M8 13v-3M12 13v-3M16 13v-3"/>',
    insta: '<rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/>',
    tiktok: '<path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.6"/>',
    envio: '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    '5e': '<circle cx="12" cy="12" r="9"/><path d="M15.5 8.5a4 4 0 1 0 0 7"/><path d="M7.5 11h6M7.5 13.5h5"/>',
    amostras: '<rect x="3" y="4" width="8" height="7" rx="1"/><rect x="13" y="4" width="8" height="7" rx="1"/><rect x="3" y="13" width="8" height="7" rx="1"/><rect x="13" y="13" width="8" height="7" rx="1"/>',
    '20p': '<path d="M3 9V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3a3 3 0 0 0 0 6v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3a3 3 0 0 0 0-6Z"/><path d="m9.5 14.5 5-5"/>',
    amigas: '<circle cx="9" cy="8" r="3.2"/><path d="M3 20c.8-3.4 3.2-5 6-5s5.2 1.6 6 5"/><circle cx="17" cy="9" r="2.6"/><path d="M16.5 14.2c2.3.2 3.9 1.7 4.5 4.3"/>',
  };
  const icone = (n) => `<span class="npts-ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">${ICONES[n] || ''}</svg></span>`;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const fmt = (s, v = {}) => String(s).replace(/\{(\w+)\}/g, (_, k) => (v[k] ?? ''));
  const euros = (v) => new Intl.NumberFormat(LOCALE, { style: 'currency', currency: 'EUR', maximumFractionDigits: v % 1 ? 2 : 0 }).format(v);
  const num = (v) => new Intl.NumberFormat(LOCALE).format(v);
  const dataCurta = (s) => new Date(/^\d{4}-\d\d-\d\d \d/.test(s) ? s.replace(' ', 'T') + 'Z' : s).toLocaleDateString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' });
  const dataLonga = (s) => new Date(s).toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });

  function nomeRecompensa(r, regras) {
    const def = (regras?.recompensas || []).find((x) => x.id === r) || {};
    return fmt(TXT.rec[r] || r, { v: euros(def.valor || 5) });
  }

  async function api(caminho, corpo) {
    const r = await fetch(API + caminho, {
      method: corpo ? 'POST' : 'GET',
      headers: corpo ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: corpo ? JSON.stringify(corpo) : undefined,
      credentials: 'same-origin',
    });
    const dados = await r.json().catch(() => ({}));
    if (!r.ok) throw Object.assign(new Error(dados.erro || r.status), { codigo: dados.erro });
    return dados;
  }

  async function carrinho() {
    const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  // Aplica o código ao carrinho (mantém os outros códigos) e pede ao tema para redesenhar o carrinho.
  async function aplicarCodigo(codigo, origem, varianteAmostras) {
    const raiz = window.Shopify?.routes?.root || '/';
    if (varianteAmostras) {
      const c = await carrinho();
      if (!c.items.some((i) => String(i.variant_id) === String(varianteAmostras))) {
        const r = await fetch(raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(varianteAmostras), quantity: 1 }] }) });
        if (!r.ok) throw new Error('catálogos');
      }
    }
    const atual = await carrinho();
    const codigos = (atual.discount_codes || []).map((d) => d.code).filter((c) => c.toUpperCase() !== codigo.toUpperCase());
    // Às vezes a Shopify deixa um código acabado de criar "não aplicável" no carrinho (os catálogos ficavam a 25 €).
    // Nesse caso tira o código e volta a pô-lo, até valer (no máximo ~7 s). O envio grátis só conta no checkout, por isso não espera por ele.
    const esperar = atual.items.length > 0 && !/^NAVITA-ENV-/i.test(codigo);
    const descontos = async (lista) => {
      const r = await fetch(raiz + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: lista.join(',') }),
      });
      return r.json().catch(() => ({}));
    };
    let vale = !esperar;
    for (let tentativa = 0; tentativa < 5 && !vale; tentativa++) {
      if (tentativa > 0) {
        await new Promise((ok) => setTimeout(ok, 1500));
        await descontos(codigos);
      }
      const c = await descontos([...codigos, codigo]);
      vale = (c.discount_codes || []).some((d) => d.code.toUpperCase() === codigo.toUpperCase() && d.applicable);
    }
    if (!esperar) await descontos([...codigos, codigo]);
    const promessa = CartLinesUpdateEvent.createPromise();
    (origem || document).dispatchEvent(
      new CartLinesUpdateEvent({ action: varianteAmostras ? 'add' : 'update', context: 'cart', lines: varianteAmostras ? [{ merchandiseId: String(varianteAmostras), quantity: 1 }] : [], promise: promessa.promise }),
    );
    promessa.resolve({ detail: {} });
    if (location.pathname.replace(/\/$/, '').endsWith('/cart')) location.reload();
    if (!vale) throw new Error('código por aplicar'); // o botão fica para tentar outra vez
  }

  /* ---------- Painel ---------- */
  const painel = document.getElementById('npts-painel');
  const caixa = painel?.querySelector('[data-npts-caixa]');
  let estado = null;
  let ultimoFoco = null;

  function abrir() {
    if (!painel) return;
    ultimoFoco = document.activeElement;
    painel.hidden = false;
    document.documentElement.classList.add('npts-aberto');
    requestAnimationFrame(() => painel.classList.add('is-aberto'));
    caixa.focus();
    if (!estado) carregar();
  }
  function fechar() {
    painel.classList.remove('is-aberto');
    document.documentElement.classList.remove('npts-aberto');
    setTimeout(() => { painel.hidden = true; }, 200);
    ultimoFoco?.focus?.();
  }

  // Regras por defeito (iguais às da app), para o painel de visita aparecer mesmo que a app não responda.
  const REGRAS_BASE = {
    registo: 5,
    redes: { instagram: 15, tiktok: 15 },
    niveis: [{ id: 'bronze', minimo: 0, pontosPorEuro: 1, aniversario: 5 }, { id: 'prata', minimo: 500, pontosPorEuro: 1.25, aniversario: 25 }, { id: 'ouro', minimo: 1250, pontosPorEuro: 1.5, aniversario: 50 }],
    recompensas: [{ id: 'envio', pontos: 150 }, { id: '5e', pontos: 250, valor: 5 }, { id: 'amostras', pontos: 350 }, { id: '20p', pontos: 500, percentagem: 20, maximo: 30 }],
    convite: { amiga: 2, minimoAmiga: 16, tu: 3 },
  };

  async function carregar() {
    caixa.innerHTML = `<p class="npts-carregar">${esc(TXT.carregar)}</p>`;
    try {
      estado = await api('estado');
      desenhar();
    } catch (e) {
      if (!cfg.sessao) {
        estado = { sessao: false, regras: REGRAS_BASE };
        desenhar();
        estado = null; // volta a tentar na próxima vez
      } else {
        caixa.innerHTML = `${cabecalhoVisita()}<p class="npts-erro">${esc(TXT.erro)}</p>`;
      }
    }
  }

  const botaoFechar = `<button type="button" class="npts-x" data-npts-fechar aria-label="${esc(TXT.fechar)}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`;
  const cabecalhoVisita = () => `<header class="npts-cab"><small>${esc(TXT.junta)}</small><h2>Navita Points</h2>${botaoFechar}</header>`;

  function desenhar() {
    const e = estado;
    const regras = e.regras || {};
    if (!e.sessao) {
      const bronze = (regras.niveis || [])[0] || { pontosPorEuro: 1 };
      caixa.innerHTML = `${cabecalhoVisita()}
        <div class="npts-visita">
          <p>${esc(TXT.visit)}</p>
          <a class="npts-btn npts-btn--cheio" href="${esc(cfg.login)}">${esc(fmt(TXT.criar, { p: regras.registo ?? 5 }))}</a>
          <p class="npts-peq">${esc(TXT.jaTens)} <a href="${esc(cfg.login)}">${esc(TXT.entrar)}</a></p>
        </div>
        <div class="npts-corpo">
          <section class="npts-sec"><h3>${esc(TXT.ganhar)}</h3>
            ${linha('saco', TXT.encomenda, fmt(TXT.porEuro, { t: `${num(bronze.pontosPorEuro)} ${TXT.pts.replace(/s$/, '')}` }))}
            ${linha('amigas', TXT.convidaTit, `${euros(regras.convite?.amiga ?? 2)} / ${euros(regras.convite?.tu ?? 3)}`)}
            ${linha('bolo', `${TXT.aniv}, Instagram, TikTok`, `${num(bronze.aniversario ?? 5)}–${num(regras.redes?.instagram ?? 15)} ${TXT.pts}`)}
          </section>
          <section class="npts-sec"><h3>${esc(TXT.recompensas)}</h3>
            ${(regras.recompensas || []).map((r) => linha(r.id, r.id === '20p' ? fmt(TXT.vinte, { m: euros(r.maximo) }) : nomeRecompensa(r.id, regras), '', `<span class="npts-pts">${num(r.pontos)} ${esc(TXT.pts)}</span>`)).join('')}
          </section>
          <p class="npts-mais"><a href="${esc(cfg.pagina)}">${esc(TXT.comoFunciona)} →</a></p>
        </div>`;
      return;
    }

    const niveis = regras.niveis || [];
    const nivelAtual = niveis.find((n) => n.id === e.nivel) || niveis[0] || {};
    const nomeNivel = (id) => TXT.niveis[id] || id;
    const proxRec = (regras.recompensas || []).map((r) => r.pontos).sort((a, b) => a - b).find((p) => p > e.saldo);
    const recProx = (regras.recompensas || []).find((r) => r.pontos === proxRec);
    const progresso = proxRec ? Math.round((e.saldo / proxRec) * 100) : 100;
    const linhaNivel = e.proximoNivel
      ? fmt(TXT.faltaNivel, { v: euros(e.proximoNivel.falta), n: nomeNivel(e.proximoNivel.id) })
      : TXT.topo;

    const codigosPorUsar = (e.codigos || []).filter((c) => !c.usado_em);
    caixa.innerHTML = `
      <header class="npts-cab">
        <small>${esc(TXT.ola)}${cfg.nome ? `, ${esc(cfg.nome)}` : ''}</small>
        <p class="npts-saldo"><b data-npts-saldo>${num(e.saldo)}</b><span>Navita Points</span></p>
        <span class="npts-nivel npts-nivel--${esc(e.nivel)}"><i></i>${esc(fmt(TXT.nivel, { n: nomeNivel(e.nivel) }))} · ${esc(linhaNivel)}</span>
        <div class="npts-prog"><p>${esc(proxRec ? fmt(TXT.faltaRec, { p: num(proxRec - e.saldo), r: nomeRecompensa(recProx.id, regras) }) : TXT.tudo)}</p><div class="npts-barra"><span style="width:${progresso}%"></span></div></div>
        ${botaoFechar}
      </header>
      <div class="npts-corpo">
        <div data-npts-codigo-novo></div>
        <section class="npts-sec"><h3>${esc(TXT.trocarTit)}</h3>
          ${(regras.recompensas || []).map((r) => linha(
            r.id,
            r.id === '20p' ? fmt(TXT.vinte, { m: euros(r.maximo) }) : nomeRecompensa(r.id, regras),
            `${num(r.pontos)} ${TXT.pts}`,
            `<button type="button" class="npts-btn npts-btn--peq" data-npts-trocar="${esc(r.id)}" ${e.saldo < r.pontos ? 'disabled' : ''}>${esc(TXT.trocar)}</button>`,
          )).join('')}
        </section>
        ${codigosPorUsar.length ? `<section class="npts-sec"><h3>${esc(TXT.codigosTit)}</h3>${codigosPorUsar.map((c) => linhaCodigo(c, regras)).join('')}</section>` : ''}
        <section class="npts-sec"><h3>${esc(TXT.ganharMais)}</h3>
          ${linha('saco', TXT.encomenda, fmt(TXT.porEuro, { t: `${num(nivelAtual.pontosPorEuro ?? 1)} ${TXT.pts.replace(/s$/, '')}` }))}
          ${linha('pessoa', TXT.registo, `${num(regras.registo ?? 5)} ${TXT.pts}`, `<span class="npts-feito">${esc(TXT.feito)}</span>`)}
          ${linha('insta', TXT.insta, `${num(regras.redes?.instagram ?? 15)} ${TXT.pts}`, e.redes?.instagram ? `<span class="npts-feito">${esc(TXT.feito)}</span>` : `<a class="npts-btn npts-btn--peq npts-btn--claro" href="${esc(cfg.instagram)}" target="_blank" rel="noopener" data-npts-seguir="instagram">${esc(TXT.seguir)}</a>`)}
          ${linha('tiktok', TXT.tiktok, `${num(regras.redes?.tiktok ?? 15)} ${TXT.pts}`, e.redes?.tiktok ? `<span class="npts-feito">${esc(TXT.feito)}</span>` : `<a class="npts-btn npts-btn--peq npts-btn--claro" href="${esc(cfg.tiktok)}" target="_blank" rel="noopener" data-npts-seguir="tiktok">${esc(TXT.seguir)}</a>`)}
          ${linhaAniversario(e, nivelAtual)}
        </section>
        <section class="npts-sec"><h3>${esc(TXT.convidaTit)}</h3>
          <div class="npts-amigas"><div><b>${euros(regras.convite?.amiga ?? 2)}</b><small>${esc(fmt(TXT.amigaRecebe, { m: euros(regras.convite?.minimoAmiga ?? 16) }))}</small></div><div><b>${euros(regras.convite?.tu ?? 3)}</b><small>${esc(TXT.tuRecebes)}</small></div></div>
          <div data-npts-convite>${e.convite ? blocoConvite(e.convite) : `<button type="button" class="npts-btn npts-btn--cheio" data-npts-criar-convite>${esc(TXT.criarLink)}</button>`}</div>
        </section>
        <section class="npts-sec"><h3>${esc(TXT.histTit)}</h3>
          <ul class="npts-hist">${(e.historico || []).filter((m) => m.pontos || m.tipo === 'convite').map((m) => linhaHistorico(m, regras)).join('')}</ul>
          ${e.validade ? `<p class="npts-peq">${esc(fmt(TXT.validade, { d: dataLonga(e.validade) }))}</p>` : ''}
        </section>
        <p class="npts-mais"><a href="${esc(cfg.pagina)}">${esc(TXT.comoFunciona)} →</a></p>
      </div>`;
    document.querySelectorAll('[data-npts-saldo-lanc]').forEach((el) => { el.textContent = num(e.saldo); });
  }

  function linha(ic, titulo, sub, direita = '') {
    return `<div class="npts-linha">${icone(ic)}<div><b>${esc(titulo)}</b>${sub ? `<small>${esc(sub)}</small>` : ''}</div>${direita}</div>`;
  }
  function linhaCodigo(c, regras) {
    return `<div class="npts-linha npts-linha--cod"><div><b>${esc(c.recompensa === 'convite-tu' ? TXT.hist.convite : nomeRecompensa(c.recompensa, regras))}</b><small><code>${esc(c.codigo)}</code></small></div><button type="button" class="npts-btn npts-btn--peq npts-btn--claro" data-npts-aplicar="${esc(c.codigo)}" data-npts-rec="${esc(c.recompensa)}">${esc(TXT.aplicar)}</button></div>`;
  }
  function linhaAniversario(e, nivelAtual) {
    const [mm, dd] = (e.aniversario || '').split('-');
    const meses = Array.from({ length: 12 }, (_, i) => `<option value="${i + 1}" ${Number(mm) === i + 1 ? 'selected' : ''}>${esc(new Date(2000, i, 1).toLocaleDateString(LOCALE, { month: 'long' }))}</option>`).join('');
    const dias = Array.from({ length: 31 }, (_, i) => `<option value="${i + 1}" ${Number(dd) === i + 1 ? 'selected' : ''}>${i + 1}</option>`).join('');
    return `<div class="npts-linha npts-linha--aniv">${icone('bolo')}<div><b>${esc(TXT.aniv)}</b><small>${esc(fmt(TXT.anivTxt, { p: nivelAtual.aniversario ?? 5 }))}</small>
      <form class="npts-aniv" data-npts-aniv><select name="dia" aria-label="${esc(TXT.dia)}" required><option value="">${esc(TXT.dia)}</option>${dias}</select><select name="mes" aria-label="${esc(TXT.mes)}" required><option value="">${esc(TXT.mes)}</option>${meses}</select><button type="submit" class="npts-btn npts-btn--peq npts-btn--claro">${esc(TXT.guardar)}</button></form></div></div>`;
  }
  function blocoConvite(c) {
    return `<div class="npts-copiar"><input value="${esc(c.link.replace(/^https?:\/\//, ''))}" readonly aria-label="${esc(TXT.convidaTit)}"><button type="button" class="npts-btn npts-btn--peq npts-btn--cheio" data-npts-copiar="${esc(c.link)}">${esc(TXT.copiar)}</button></div>${c.convidadas ? `<p class="npts-peq">${esc(fmt(TXT.convidadas, { n: c.convidadas }))}</p>` : ''}`;
  }
  function linhaHistorico(m, regras) {
    const texto = fmt(TXT.hist[m.tipo] || m.tipo, { d: m.descricao || '', n: TXT.niveis[m.descricao] || m.descricao, r: nomeRecompensa(m.descricao, regras) });
    const sinal = m.pontos > 0 ? `<span class="npts-mais-p">+${num(m.pontos)}</span>` : m.pontos < 0 ? `<span class="npts-menos-p">−${num(-m.pontos)}</span>` : '';
    return `<li><span>${esc(texto)}<time>${esc(dataCurta(m.criado_em))}</time></span>${sinal}</li>`;
  }

  async function copiar(texto, botao) {
    try { await navigator.clipboard.writeText(texto); } catch { /* sem acesso à área de transferência */ }
    const antes = botao.textContent;
    botao.textContent = TXT.copiado;
    setTimeout(() => { botao.textContent = antes; }, 1500);
  }

  // Troca pontos (painel ou carrinho). Os 20% precisam do valor do carrinho.
  async function trocar(botao) {
    const id = botao.dataset.nptsTrocar;
    const antes = botao.textContent;
    botao.disabled = true;
    botao.textContent = TXT.aTrocar;
    const noCarrinho = !painel?.contains(botao);
    const avisoEl = noCarrinho ? botao.closest('[data-npts-carrinho]')?.querySelector('[data-npts-aviso]') : caixa.querySelector('[data-npts-codigo-novo]');
    try {
      let subtotal;
      if (id === '20p') {
        const c = await carrinho();
        subtotal = c.items_subtotal_price / 100;
        if (!(subtotal > 0)) throw Object.assign(new Error('carrinho'), { codigo: 'carrinho' });
      }
      const r = await api('trocar', { recompensa: id, subtotal });
      const regras = estado?.regras;
      if (estado) { estado = null; } // o painel volta a pedir o estado da próxima vez
      document.querySelectorAll('[data-npts-saldo-lanc]').forEach((el) => { el.textContent = num(r.saldo); });
      if (noCarrinho) {
        await aplicarCodigo(r.codigo, botao, id === 'amostras' ? r.variante : null);
        return;
      }
      // Aplica logo no carrinho (os catálogos só vão na encomenda se estiverem no carrinho; ver a #NO4913).
      let aplicado = false;
      try { await aplicarCodigo(r.codigo, botao, id === 'amostras' ? r.variante : null); aplicado = true; } catch { /* fica o botão para tentar outra vez */ }
      await carregar();
      const alvo = caixa.querySelector('[data-npts-codigo-novo]');
      alvo.innerHTML = `<div class="npts-codigo"><p>${esc(nomeRecompensa(id, regras || estado?.regras))} · ${esc(TXT.soTeu)}</p><code>${esc(r.codigo)}</code><div><button type="button" class="npts-btn npts-btn--peq npts-btn--cheio" data-npts-aplicar="${esc(r.codigo)}" data-npts-rec="${esc(id)}" ${aplicado ? 'disabled' : ''}>${esc(aplicado ? TXT.aplicado : TXT.aplicar)}</button><button type="button" class="npts-btn npts-btn--peq npts-btn--claro" data-npts-copiar="${esc(r.codigo)}">${esc(TXT.copiar)}</button></div></div>`;
      alvo.scrollIntoView({ block: 'nearest' });
    } catch (e) {
      botao.disabled = false;
      botao.textContent = antes;
      const msg = e.codigo === 'saldo' ? TXT.erroSaldo : e.codigo === 'carrinho' ? TXT.vinteCarrinho : TXT.erro;
      if (avisoEl) { avisoEl.hidden = false; avisoEl.innerHTML = `<p class="npts-erro">${esc(msg)}</p>`; }
    }
  }

  document.addEventListener('click', async (ev) => {
    const t = ev.target;
    if (t.closest('[data-npts-abrir]')) { ev.preventDefault(); abrir(); return; }
    if (t.closest('[data-npts-fechar]')) { fechar(); return; }
    const bTrocar = t.closest('[data-npts-trocar]');
    if (bTrocar) { trocar(bTrocar); return; }
    const bAplicar = t.closest('[data-npts-aplicar]');
    if (bAplicar) {
      bAplicar.disabled = true;
      const variante = bAplicar.dataset.nptsRec === 'amostras' ? estado?.regras?.amostrasVariante || null : null;
      try { await aplicarCodigo(bAplicar.dataset.nptsAplicar, bAplicar, variante); bAplicar.textContent = TXT.aplicado; } catch { bAplicar.disabled = false; }
      return;
    }
    const bCopiar = t.closest('[data-npts-copiar]');
    if (bCopiar) { copiar(bCopiar.dataset.nptsCopiar, bCopiar); return; }
    const bSeguir = t.closest('[data-npts-seguir]');
    if (bSeguir) {
      // abre a rede social (link normal) e regista os pontos
      api('seguir', { rede: bSeguir.dataset.nptsSeguir }).then(() => { estado = null; carregar(); }).catch(() => {});
      return;
    }
    const bConvite = t.closest('[data-npts-criar-convite]');
    if (bConvite) {
      bConvite.disabled = true;
      try {
        const c = await api('convite', {});
        bConvite.closest('[data-npts-convite]').innerHTML = blocoConvite(c);
      } catch { bConvite.disabled = false; }
    }
  });

  document.addEventListener('submit', async (ev) => {
    const f = ev.target.closest('[data-npts-aniv]');
    if (!f) return;
    ev.preventDefault();
    const b = f.querySelector('button');
    b.disabled = true;
    try {
      await api('aniversario', { dia: f.dia.value, mes: f.mes.value });
      b.textContent = TXT.guardado;
    } catch {
      b.disabled = false;
    }
  });

  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape' && painel && !painel.hidden) fechar();
  });

  // Link direto para o painel: navita.pt/#navita-points
  if (location.hash === '#navita-points') abrir();

  window.navitaPontos = { abrir, aplicarCodigo };
}
